// JSON-LD for the `gift_thank` surface — a static thank-you page after
// claiming a gift. Minimal WebPage tied to the site Organization.

import type { ShareSurface } from '@/lib/share/events';

import { organizationId, websiteId } from './site';
import type { JsonLdBuilderContext, JsonLdPayload } from './types';

export function buildGiftThankJsonLd(
  _surface: Extract<ShareSurface, { kind: 'gift_thank' }>,
  ctx: JsonLdBuilderContext,
): JsonLdPayload {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${ctx.pageUrl}#webpage`,
    url: ctx.pageUrl,
    name: ctx.name ?? 'Gift claimed on Morfi',
    ...(ctx.description !== undefined ? { description: ctx.description } : {}),
    primaryImageOfPage: { '@type': 'ImageObject', url: ctx.ogImageUrl },
    isPartOf: { '@id': websiteId() },
    publisher: { '@id': organizationId() },
  };
}
